import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export default function Footer() {
  const { t } = useTranslation();

  const MySwal = withReactContent(Swal);

  const [email, setEmail] = useState("");

  const handleSubscribe = async () => {
    if (!email) {
      MySwal.fire({
        icon: "warning",
        title: t("Please enter your email"),
      });
      return;
    }

    try {
      const res = await fetch("https://ma-laravel.ma-uae.com/api/emails", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (res.ok) {
        setEmail("");
        MySwal.fire({
          icon: "success",
          title: t("Thank you!"),
          text: t("Your email has been subscribed successfully."),
        });
      } else {
        const data = await res.json();
        MySwal.fire({
          icon: "error",
          title: t("Oops..."),
          text: data.message || t("Something went wrong."),
        });
      }
    } catch (error) {
      MySwal.fire({
        icon: "error",
        title: t("Error"),
        text: t("Unable to connect to the server."),
      });
    }
  };

  return (
    <footer className="bg-[#242830] flex flex-col gap-[10px] border-t-[1px] border-t-black">
      <div className="f-col p-[35px] container flex flex-col md:flex-row justify-between gap-[40px] border-b-[1px] border-b-[#7B7B7B]">
        <div className="w-full md:w-[35%] flex flex-col gap-[40px]">
          <div className="flex flex-col gap-[8px]">
            <Link to={"/"}>
              <img
                className="w-[250px] h-[150px]"
                src={require("../../assets/logo/white-logo.svg").default}
                alt=""
              />
            </Link>
            <p className="text-[15px] text-white">
              {t(
                `
              At MA Partners Chartered Accountants, we prioritize your goals, deliver professional solutions, uphold integrity, and drive business success through trusted expertise and commitment in Abu Dhabi, UAE.
              `
              )}
            </p>
          </div>
          <div className="flex flex-col gap-[8px]">
            <div className="text-white">{t("Follow Us:")}</div>
            <div className="flex items-center gap-[8px]">
              <Link to={"https://www.instagram.com/monmedia.group?igsh=aGlqb3p3bGxvbzJu"}>
                <img
                  className="w-[28px] h-[28px]"
                  src={require("../../assets/icons/insta.svg").default}
                  alt=""
                />
              </Link>
            </div>
          </div>
        </div>
        <div className="w-full md:w-[65%] flex flex-col md:flex-row gap-[20px] justify-between">
          <div className="flex-1 flex flex-col gap-[12px]">
            <div className="text-[20px] font-bold text-white">
              {t("Quick links")}
            </div>
            <ul className="flex flex-col gap-[10px]">
              <li>
                <Link className="text-white text-[16px]" to={"/"}>
                  {t("Home")}
                </Link>
              </li>
              <li>
                <Link className="text-white text-[16px]" to={"/about"}>
                  {t("About us")}
                </Link>
              </li>
              <li>
                <Link className="text-white text-[16px]" to={"/services"}>
                  {t("Services")}
                </Link>
              </li>
              <li>
                <Link className="text-white text-[16px]" to={"/teachers"}>
                  {t("Our Team")}
                </Link>
              </li>
              <li>
                <Link className="text-white text-[16px]" to={"/blog"}>
                  {t("Contact us")}
                </Link>
              </li>
            </ul>
          </div>
          <div className="flex-1 flex flex-col gap-[12px]">
            <div className="text-[20px] font-bold text-white">
              {t("Get in touch")}
            </div>
            <ul className="flex flex-col gap-[10px]">
              <li>
                <Link
                  to={"tel:026413666"}
                  className="flex items-center gap-[6px]"
                >
                  <img
                    className="w-[20px] h-[20px]"
                    src={require("../../assets/icons/phone.svg").default}
                    alt=""
                  />
                  <span className="text-white dir-ar">026413666</span>
                </Link>
              </li>
              <li>
                <Link
                  to={"mailto:Mapartner@outlook.com"}
                  className="flex items-center gap-[6px]"
                >
                  <img
                    className="w-[20px] h-[20px]"
                    src={require("../../assets/icons/email.svg").default}
                    alt=""
                  />
                  <span className="text-white">Mapartner@outlook.com</span>
                </Link>
              </li>
              <li>
                <Link
                  to={"https://maps.app.goo.gl/LPnf9sd1ypMykFSq7"}
                  className="flex items-center gap-[6px]"
                >
                  <img
                    className="w-[20px] h-[20px]"
                    src={require("../../assets/icons/location.svg").default}
                    alt=""
                  />
                  <span className="text-white">
                    {t("Al Wahda Commercial Tower, Office No. 101")}
                  </span>
                </Link>
              </li>
            </ul>
          </div>
          <div className="flex-1 flex flex-col gap-[12px]">
            <div className="text-[20px] font-bold text-white">SUBSCRIBE</div>
            <p className="text-[#7B7B7B] text-sm mb-4">
              {t("Subscribe to our newsletter. Be always in trend!")}
            </p>
            <div className="flex items-center">
              <input
                type="email"
                placeholder={t("Enter your email")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="p-2 rounded-l-md bg-[#333] text-white border-none focus:outline-none w-full"
              />
              <button
                onClick={handleSubscribe}
                className="bg-[#4A90E2] text-white p-2 rounded-r-md flex items-center justify-center w-[60px]"
              >
                <span className="text-xl">➤</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#242830] py-[15px] text-white text-center font-bold">
        <div className="container mx-auto px-4">
          {t(
            "Copyright © 2025 MA Partners Chartered Accountants. All Rights Reserved."
          )}
        </div>
      </div>
    </footer>
  );
}
